import React, { useState, useEffect } from 'react';
import firebase from 'firebase/compat/app';
import { useTable } from 'react-table';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '../../../custom/CustomDialogue';
import Button from '../../../custom/Button';
import Input from '../../../custom/Input';
import Label from '../../../custom/Label';

const UpdateUserDialog = ({ user, onUpdate }) => {
  const [name, setName] = useState(user.name);
  const [email, setEmail] = useState(user.email);

  const handleSubmit = (event) => {
    event.preventDefault();
    onUpdate(user.id, { name, email });
  };

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant="outline">Update</Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Update User</DialogTitle>
          <DialogDescription>
            Update the user's information here. Click save when you're done.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="grid gap-4 py-4">
          <div className="grid grid-cols-4 items-center gap-4">
            <Label htmlFor="name" className="text-right">
              Name
            </Label>
            <Input
              id="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="col-span-3"
            />
          </div>
          <div className="grid grid-cols-4 items-center gap-4">
            <Label htmlFor="email" className="text-right">
              Email
            </Label>
            <Input
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="col-span-3"
            />
          </div>
          <DialogFooter>
            <Button type="submit">Save changes</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
const AdminTools = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    const db = firebase.firestore();
    db.collection('users').onSnapshot((snapshot) => {
      const userData = [];
      snapshot.forEach((doc) => userData.push({ ...doc.data(), id: doc.id }));
      setUsers(userData);
      setLoading(false);
    });
  }, []);

  const updateUser = (id, updatedUser) => {
    firebase.firestore().collection('users').doc(id).update(updatedUser);
  };

  const disableUser = (id) => {
    firebase.firestore().collection('users').doc(id).update({ disabled: true });
  };

  const deleteUser = (id) => {
    firebase.firestore().collection('users').doc(id).delete();
  };

  const columns = React.useMemo(
    () => [
      {
        Header: 'Name',
        accessor: 'name',
      },
      {
        Header: 'Email',
        accessor: 'email',
      },
      {
        Header: 'Activity',
        accessor: 'activity',
      },
      {
        Header: 'Actions',
        id: 'actions',
        Cell: ({ row: { original } }) => (
            <div>
            <UpdateUserDialog user={original} onUpdate={updateUser} />
            <button onClick={() => disableUser(original.id)}>Disable</button>
            <button onClick={() => deleteUser(original.id)}>Delete</button>
          </div>
        ),
      },
    ],
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable({ columns, data: users });

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <h2>Admin Tools</h2>
      <table {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps()}>{column.render('Header')}</th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map((cell) => (
                  <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default AdminTools;

